import React from 'react';
import { aboutFeatures, teamImages } from '../data/mock';
import {
  Calendar,
  Star,
  ShieldCheck,
  Users,
  Calculator,
  CreditCard,
} from 'lucide-react';

const iconMap = {
  calendar: Calendar,
  star: Star,
  'shield-check': ShieldCheck,
  users: Users,
  calculator: Calculator,
  'credit-card': CreditCard,
};

const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Несколько слов о нас
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {aboutFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="group p-6 rounded-xl hover:bg-orange-50 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-orange-100 to-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <IconComponent className="w-7 h-7 text-orange-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Team Images */}
        <div className="grid md:grid-cols-3 gap-6">
          {teamImages.map((image, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-2xl aspect-[4/3] group"
            >
              <img
                src={image}
                alt={`Team member ${index + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;